import { Outlet, NavLink, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import {
  LayoutDashboard,
  Box,
  Boxes,
  Cog,
  ClipboardList,
  ClipboardCheck,
  Factory,
  ShieldCheck,
  FileBarChart,
  LogOut,
  Menu,
  X,
  Wrench,
  User,
  Package,
  Users,
  DollarSign,
  Bell,
  Award,
  CalendarDays,
  Settings,
  CalendarRange,
  Settings2,
  FileText,
  MessageCircle,
  Download,
  Activity,
  Home,
  QrCode,
  Clock,
  Layers,
  Search,
  ChevronDown,
  MapPin,
  Sparkles,
  Warehouse,
  TrendingDown,
} from "lucide-react";
import { useState, useEffect } from "react";
import GlobalSearch from "./GlobalSearch";
import OvertimePromptModal from "./OvertimePromptModal";

const navGroups = [
  {
    id: "principal",
    label: "Principal",
    alwaysOpen: true,
    items: [
      { path: "/", label: "Início", icon: Home, roles: ["admin", "operator", "quality", "shift_leader", "display"] },
      { path: "/ai-assistant", label: "Assistente IA", icon: Sparkles, roles: ["admin", "shift_leader", "quality", "operator"] },
      { path: "/executive", label: "Dashboard Executivo", icon: LayoutDashboard, roles: ["admin", "shift_leader"] },
      { path: "/dashboard", label: "Dashboard", icon: LayoutDashboard, roles: ["admin", "operator", "quality", "shift_leader", "display"] },
      { path: "/messages", label: "Mensagens", icon: MessageCircle, roles: ["admin", "operator", "quality", "shift_leader"] },
    ],
  },
  {
    id: "producao",
    label: "Produção",
    items: [
      { path: "/orders", label: "Ordens", icon: ClipboardList, roles: ["admin", "quality", "shift_leader"] },
      { path: "/planeamento", label: "Planeamento", icon: CalendarDays, roles: ["admin", "quality", "shift_leader"] },
      { path: "/gantt", label: "Gantt Visual", icon: CalendarDays, roles: ["admin", "quality", "shift_leader"] },
      { path: "/shop-floor", label: "Chão de Fábrica", icon: Factory, roles: ["admin", "operator", "quality", "shift_leader", "display"] },
      { path: "/shop-floor-2", label: "Chão de Fábrica 2", icon: Factory, roles: ["admin", "operator", "quality", "shift_leader", "display"] },
      { path: "/shop-floor-3", label: "Painel de Fábrica 3", icon: Factory, roles: ["admin", "operator", "quality", "shift_leader", "display"] },
      { path: "/factory-map", label: "Mapa da Fábrica", icon: MapPin, roles: ["admin", "operator", "quality", "shift_leader", "display"] },
      { path: "/operator-panel", label: "Painel Operador", icon: User, roles: ["admin", "operator", "quality", "shift_leader"] },
      { path: "/reports", label: "Relatórios", icon: FileBarChart, roles: ["admin", "quality", "shift_leader"] },
      { path: "/oee", label: "Dashboard OEE", icon: Activity, roles: ["admin", "quality", "shift_leader"] },
    ],
  },
  {
    id: "qualidade",
    label: "Qualidade",
    items: [
      { path: "/quality-control-plans", label: "PCQ - Controlo Qualidade", icon: ClipboardCheck, roles: ["admin", "quality", "shift_leader"] },
      { path: "/approvals", label: "Aprovações", icon: ClipboardCheck, roles: ["admin", "quality", "shift_leader"] },
      { path: "/quality", label: "Controlos Qualidade", icon: ShieldCheck, roles: ["admin", "operator", "quality", "shift_leader"] },
      { path: "/spc", label: "SPC (Cp/Cpk)", icon: Activity, roles: ["admin", "quality", "shift_leader"] },
      { path: "/pareto", label: "Pareto Desperdício", icon: TrendingDown, roles: ["admin", "quality", "shift_leader"] },
      { path: "/quality-inspections", label: "Técnico Qualidade", icon: ClipboardCheck, roles: ["admin", "quality", "shift_leader"] },
      { path: "/iso9001", label: "Gestão ISO 9001", icon: Award, roles: ["admin", "quality", "shift_leader"] },
      { path: "/work-instructions", label: "Instruções de Trabalho", icon: FileText, roles: ["admin", "quality", "shift_leader"] },
    ],
  },
  {
    id: "engenharia",
    label: "Engenharia",
    items: [
      { path: "/bom", label: "BOM / Estrutura", icon: Layers, roles: ["admin", "quality", "shift_leader"] },
      { path: "/parts", label: "Peças", icon: Box, roles: ["admin", "quality", "shift_leader"] },
      { path: "/molds", label: "Moldes", icon: Boxes, roles: ["admin", "quality", "shift_leader"] },
      { path: "/machines", label: "Máquinas", icon: Cog, roles: ["admin", "operator", "quality", "shift_leader"] },
      { path: "/packaging", label: "Embalagens", icon: Package, roles: ["admin", "quality", "shift_leader"] },
    ],
  },
  {
    id: "manutencao",
    label: "Manutenção",
    items: [
      { path: "/preventive-maintenance", label: "Preventiva", icon: Wrench, roles: ["admin", "quality", "shift_leader"] },
      { path: "/mold-maintenance", label: "Manutenção Moldes", icon: Wrench, roles: ["admin", "quality", "shift_leader"] },
      { path: "/reliability", label: "MTTR / MTBF", icon: Activity, roles: ["admin", "quality", "shift_leader"] },
      { path: "/cmms", label: "Manutenção (CMMS)", icon: Wrench, roles: ["admin", "shift_leader", "quality"] },
      { path: "/machine-management", label: "Gestão Máquinas", icon: Settings, roles: ["admin", "quality", "shift_leader"] },
    ],
  },
  {
    id: "comercial",
    label: "Comercial",
    items: [
      { path: "/clients", label: "Clientes", icon: FileText, roles: ["admin", "quality", "shift_leader"] },
      { path: "/purchase-orders", label: "Notas de Encomenda", icon: FileText, roles: ["admin"] },
      { path: "/sales-guides", label: "Guias de Venda", icon: FileText, roles: ["admin", "quality", "shift_leader"] },
      { path: "/billing", label: "Faturação", icon: FileText, roles: ["admin"] },
      { path: "/sales-report", label: "Relatório de Vendas", icon: FileText, roles: ["admin", "quality", "shift_leader"] },
      { path: "/fulfilled-orders", label: "Encomendas Finalizadas", icon: ClipboardCheck, roles: ["admin", "quality", "shift_leader"] },
    ],
  },
  {
    id: "logistica",
    label: "Logística & Etiquetas",
    items: [
      { path: "/raw-materials", label: "Matéria-Prima", icon: Package, roles: ["admin", "quality", "shift_leader"] },
      { path: "/stocks", label: "Armazém", icon: Package, roles: ["admin", "quality", "shift_leader"] },
      { path: "/wms", label: "WMS (Lotes/FIFO)", icon: Warehouse, roles: ["admin", "quality", "shift_leader", "operator"] },
      { path: "/part-labels", label: "Etiquetas QR (Peça)", icon: FileText, roles: ["admin", "quality", "shift_leader", "operator"] },
      { path: "/box-labels", label: "Etiquetas de Caixa", icon: QrCode, roles: ["admin", "quality", "shift_leader", "operator"] },
    ],
  },
  {
    id: "gestao",
    label: "Gestão",
    items: [
      { path: "/users", label: "Utilizadores", icon: Users, roles: ["admin"] },
      { path: "/qr-badges", label: "Crachás QR", icon: QrCode, roles: ["admin"] },
      { path: "/visitors", label: "Visitantes", icon: ShieldCheck, roles: ["admin", "shift_leader", "quality"] },
      { path: "/portal-invites", label: "Portal Cliente", icon: Users, roles: ["admin"] },
      { path: "/molds-qr-labels", label: "Crachás QR Moldes", icon: QrCode, roles: ["admin", "shift_leader"] },
      { path: "/gate", label: "Portaria (Quiosque)", icon: ShieldCheck, roles: ["admin", "shift_leader", "quality"] },
      { path: "/time-tracking", label: "Registo de Ponto", icon: Clock, roles: ["admin", "shift_leader"] },
      { path: "/old-shifts", label: "Turnos Antigos (Cleanup)", icon: Clock, roles: ["admin"] },
      { path: "/shift-schedule", label: "Gestão de Turnos", icon: CalendarRange, roles: ["admin", "operator", "quality", "shift_leader"] },
      { path: "/cost-control", label: "Controlo de Custos", icon: DollarSign, roles: ["admin"] },
      { path: "/costing", label: "Custeio Industrial", icon: DollarSign, roles: ["admin", "shift_leader", "quality"] },
      { path: "/alerts", label: "Alertas", icon: Bell, roles: ["admin", "quality", "shift_leader"] },
      { path: "/notification-settings", label: "Notificações", icon: Bell, roles: ["admin"] },
      { path: "/settings", label: "Configurações", icon: Settings2, roles: ["admin", "quality", "shift_leader"] },
      { path: "/download", label: "Instalar App", icon: Download, roles: ["admin", "operator", "quality", "shift_leader"] },
    ],
  },
];

// Flat list mantida para compatibilidade
const navItems = navGroups.flatMap(g => g.items);

const LOGO_URL = "https://customer-assets.emergentagent.com/job_a6fd91e7-1ad0-4cf0-91ce-b769f9bab27a/artifacts/m0y29wqk_Sem%20T%C3%ADtulo.png";

export default function Layout() {
  const { user, logout, clockedIn, clockInTime } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  const isShopFloor = location.pathname === "/shop-floor" || location.pathname === "/shop-floor-2" || location.pathname === "/shop-floor-3";
  
  // Auto-collapse sidebar for display users and shop floor pages
  const [sidebarOpen, setSidebarOpen] = useState(user?.role !== "display");
  const [elapsedTime, setElapsedTime] = useState("");

  // Keep sidebar collapsed for display users and shop floor
  useEffect(() => {
    if (user?.role === "display" || isShopFloor) {
      setSidebarOpen(false);
    }
  }, [user?.role, isShopFloor]);

  useEffect(() => {
    if (clockedIn && clockInTime) {
      const updateElapsed = () => {
        const now = new Date();
        const start = new Date(clockInTime);
        const diff = Math.floor((now - start) / 1000);
        const hours = Math.floor(diff / 3600);
        const mins = Math.floor((diff % 3600) / 60);
        setElapsedTime(`${hours}h ${mins.toString().padStart(2, '0')}m`);
      };
      
      updateElapsed();
      const interval = setInterval(updateElapsed, 60000);
      return () => clearInterval(interval);
    }
  }, [clockedIn, clockInTime]);

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  const filteredNavItems = navItems.filter(
    (item) => item.roles.includes(user?.role)
  );

  // Grupos filtrados por role, mantendo estado colapsado por grupo
  const filteredGroups = navGroups
    .map(g => ({...g, items: g.items.filter(it => it.roles.includes(user?.role))}))
    .filter(g => g.items.length > 0);

  // Estado: quais grupos estao abertos. Sempre abre o grupo que contem a rota actual.
  const [openGroups, setOpenGroups] = useState(() => {
    const s = {};
    filteredGroups.forEach(g => { s[g.id] = g.alwaysOpen || false; });
    return s;
  });
  // Nav search filter
  const [navFilter, setNavFilter] = useState("");
  const navFilterLower = navFilter.trim().toLowerCase();

  // Manter grupo actual aberto
  useEffect(() => {
    const currentGroup = filteredGroups.find(g => g.items.some(it => it.path === location.pathname));
    if (currentGroup && !openGroups[currentGroup.id]) {
      setOpenGroups(prev => ({ ...prev, [currentGroup.id]: true }));
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  const isDisplayUser = user?.role === "display";
  const isHomePage = location.pathname === "/";
  
  // Esconder o badge "Made with Emergent" apenas para utilizadores display (TV)
  useEffect(() => {
    const badge = document.getElementById("emergent-badge");
    if (badge) {
      badge.style.display = isDisplayUser ? "none" : "inline-flex";
    }
  }, [isDisplayUser]);

  const getRoleLabel = (role) => {
    const labels = {
      admin: "Administrador",
      operator: "Operador",
      quality: "Qualidade",
      shift_leader: "Chefe de Turno",
      display: "Display TV"
    };
    return labels[role] || role;
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Mobile Header - hidden for display users and on home page */}
      {!isDisplayUser && !isHomePage && (
        <header className="lg:hidden bg-card border-b border-border fixed top-0 left-0 right-0 z-50">
          <div className="flex items-center justify-between px-4 py-3">
            <div className="flex items-center gap-3">
              <Button
                variant="ghost"
                size="icon"
                onClick={() => setSidebarOpen(!sidebarOpen)}
                data-testid="mobile-menu-toggle"
              >
                {sidebarOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
              </Button>
              <img 
                src={LOGO_URL}
                alt="Logo" 
                className="h-8 w-auto object-contain"
              />
            </div>
            <div className="flex items-center gap-2">
              <span className="text-sm text-foreground">{user?.name}</span>
            </div>
          </div>
        </header>
      )}

      {/* Desktop Top Bar (with Global Search) */}
      {!isDisplayUser && !isHomePage && !isShopFloor && (
        <header className="hidden lg:flex fixed top-0 right-0 left-64 z-40 bg-white/95 backdrop-blur border-b border-slate-200 h-12 items-center px-4 gap-3">
          <GlobalSearch />
          <div className="flex-1"></div>
          <div className="text-xs text-muted-foreground">
            {user?.name} · <span className="uppercase font-semibold">{getRoleLabel(user?.role)}</span>
          </div>
        </header>
      )}

      {/* Mobile Sidebar Overlay */}
      {sidebarOpen && (
        <div
          className={`${isShopFloor ? '' : 'lg:hidden'} fixed inset-0 bg-black/50 z-40`}
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar - escondido na pagina de inicio */}
      {!isHomePage && (
      <aside
        className={`
          fixed top-0 left-0 z-50 h-full w-64 bg-card border-r border-border
          transform transition-transform duration-200 ease-in-out
          ${isShopFloor ? '' : 'lg:translate-x-0'}
          ${sidebarOpen ? "translate-x-0" : "-translate-x-full"}
        `}
      >
        <div className="flex flex-col h-full">
          {/* Logo */}
          <div className="p-4 border-b border-border">
            <img 
              src={LOGO_URL}
              alt="Logo" 
              className="h-14 w-auto object-contain"
            />
          </div>

          {/* Nav Search */}
          <div className="px-3 pt-3 pb-1">
            <div className="relative">
              <Search className="absolute left-2 top-2.5 h-3.5 w-3.5 text-slate-400" />
              <input
                type="search"
                value={navFilter}
                onChange={e => setNavFilter(e.target.value)}
                placeholder="Filtrar menu..."
                className="w-full h-8 pl-7 pr-2 text-xs rounded-md border border-input bg-background"
                data-testid="nav-filter"
              />
            </div>
          </div>

          {/* Navigation - Grouped */}
          <nav className="flex-1 px-2 pb-3 space-y-1 overflow-y-auto">
            {filteredGroups.map((group) => {
              const itemsToShow = navFilterLower
                ? group.items.filter(it => it.label.toLowerCase().includes(navFilterLower))
                : group.items;
              if (itemsToShow.length === 0) return null;
              const isOpen = navFilterLower ? true : (group.alwaysOpen || openGroups[group.id]);
              return (
                <div key={group.id} className="mb-1">
                  {!group.alwaysOpen && (
                    <button
                      onClick={() => setOpenGroups(p => ({ ...p, [group.id]: !p[group.id] }))}
                      className="w-full flex items-center justify-between px-2 py-1.5 text-[10px] font-bold uppercase tracking-wider text-slate-400 hover:text-slate-700 transition-colors"
                      data-testid={`nav-group-${group.id}`}
                    >
                      <span>{group.label}</span>
                      <ChevronDown className={`h-3 w-3 transition-transform ${isOpen ? "" : "-rotate-90"}`} />
                    </button>
                  )}
                  {group.alwaysOpen && (
                    <div className="px-2 py-1 text-[10px] font-bold uppercase tracking-wider text-slate-400">{group.label}</div>
                  )}
                  {isOpen && (
                    <div className="space-y-0.5">
                      {itemsToShow.map((item) => (
                        <NavLink
                          key={item.path}
                          to={item.path}
                          onClick={() => setSidebarOpen(false)}
                          end={item.path === "/"}
                          className={({ isActive }) =>
                            `flex items-center gap-3 px-3 py-2 rounded-md transition-default text-sm
                            ${
                              isActive
                                ? "bg-primary text-primary-foreground"
                                : "text-muted-foreground hover:text-foreground hover:bg-secondary"
                            }`
                          }
                          data-testid={`nav-${item.path.replace(/\//g, "") || "home"}`}
                        >
                          <item.icon className="h-4 w-4 shrink-0" />
                          <span className="font-medium text-xs">{item.label}</span>
                        </NavLink>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
            {navFilterLower && filteredGroups.every(g => g.items.every(it => !it.label.toLowerCase().includes(navFilterLower))) && (
              <div className="text-center text-xs text-muted-foreground py-4">Sem resultados</div>
            )}
          </nav>

          {/* User Info */}
          <div className="p-4 border-t border-border">
            <div className="flex items-center gap-3 mb-3">
              <div className="h-10 w-10 rounded-md bg-primary/10 flex items-center justify-center">
                <span className="font-chivo font-bold text-lg text-primary">
                  {user?.name?.charAt(0).toUpperCase()}
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-medium text-sm truncate text-foreground">{user?.name}</p>
                <p className="text-xs text-muted-foreground">
                  {getRoleLabel(user?.role)}
                </p>
              </div>
            </div>
            
            {/* Time Tracking Indicator */}
            {clockedIn && (
              <div className="mb-3 p-2 bg-green-50 border border-green-200 rounded-md">
                <div className="flex items-center justify-between">
                  <span className="text-xs text-green-700 font-medium">Em serviço</span>
                  <span className="text-sm font-bold text-green-800">{elapsedTime}</span>
                </div>
              </div>
            )}
            
            <Button
              variant="outline"
              className="w-full justify-start"
              onClick={handleLogout}
              data-testid="logout-button"
            >
              <LogOut className="h-4 w-4 mr-2" />
              Terminar Sessão
            </Button>
          </div>
        </div>
      </aside>
      )}

      {/* Main Content */}
      <main className={`${isShopFloor || isHomePage ? '' : 'lg:ml-64'} min-h-screen ${isHomePage ? '' : (isShopFloor ? 'pt-16 lg:pt-0' : 'pt-16 lg:pt-12')}`}>
        <div className={isShopFloor || isHomePage ? '' : 'p-4 md:p-6 lg:p-8'}>
          <Outlet />
          <OvertimePromptModal />
        </div>
      </main>

      {/* Botao "Voltar ao Inicio" - visivel em TODAS as paginas excepto na home.
          Para display users (TV) fica em bottom-right normal. Para outros, sobe
          80px para nao ficar por baixo do badge "Made with Emergent". */}
      {location.pathname !== "/" && (
        <button
          onClick={() => navigate("/")}
          className={`fixed ${isDisplayUser ? "bottom-6" : "bottom-20"} right-6 z-50 bg-slate-900 hover:bg-blue-700 text-white px-6 py-4 rounded-full shadow-2xl transition-all hover:scale-110 active:scale-95 flex items-center gap-2 font-bold text-base border-2 border-white/20`}
          data-testid="back-to-home-btn"
          title="Voltar ao Inicio"
          style={{ minWidth: "60px", minHeight: "60px" }}
        >
          <Home className="h-6 w-6" />
          <span className="hidden sm:inline">Início</span>
        </button>
      )}

      {/* Floating menu button for shop floor */}
      {isShopFloor && !sidebarOpen && (
        <button
          onClick={() => setSidebarOpen(true)}
          className="fixed top-4 left-4 z-40 bg-slate-900/80 hover:bg-slate-800 text-white p-2 rounded-lg shadow-lg backdrop-blur-sm transition-all"
          data-testid="shop-floor-menu-btn"
        >
          <Menu className="h-5 w-5" />
        </button>
      )}
    </div>
  );
}
